import { memberName } from "./memberNames";

export const CALLER_MAX = 200;
export const RESULT_MAX = 1000;
// The API sends at most this many calls; see CALLS_SHOWN in platform/api/app/store.py.
export const CALLS_SHOWN = 50;
export const CALLS_FIRST = 5;

export const REASONS = ["pickup_request", "overflow", "billing", "complaint", "other"] as const;
export type Reason = (typeof REASONS)[number];

export const REASON_TEXT: Record<Reason, string> = {
  pickup_request: "Pickup request",
  overflow: "Overflow",
  billing: "Billing",
  complaint: "Complaint",
  other: "Other",
};

export type CallProblem = { field: "caller" | "result"; text: string };

/** The first problem in the call form, with the field that has it. */
export function callProblem(caller: string, result: string): CallProblem | null {
  if (!caller.trim()) return { field: "caller", text: "Enter who called." };
  if (caller.trim().length > CALLER_MAX) return { field: "caller", text: `The caller can have ${CALLER_MAX} characters at most.` };
  if (result.trim().length > RESULT_MAX) return { field: "result", text: `The result can have ${RESULT_MAX} characters at most.` };
  return null;
}

export function callError(caller: string, result: string): string {
  return callProblem(caller, result)?.text ?? "";
}

/** The date and time of a call in the time zone of the organization. */
export function callTime(at: string, timeZone: string): string {
  return new Date(at).toLocaleString("en-US", {
    timeZone,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
}

/** "Oct 12, 2:05 PM", the short time of a table cell. callTime gives the full time for its title. */
export function shortTime(at: string, timeZone: string): string {
  return new Date(at).toLocaleString("en-US", { timeZone, month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

/** The member name of an email, else the part before the "@", for a table cell. */
export const emailName = (email: string) => memberName(email);

/** The day of a call in the time zone of the organization, as YYYY-MM-DD. */
export function callDay(at: string, timeZone: string): string {
  return new Date(at).toLocaleDateString("en-CA", { timeZone });
}
